import {
  Avatar,
  Link,
  makeStyles,
  ListItem,
  List,
  ListItemIcon,
  ListItemText,
  Grid,
  Divider,
  Box,
  Typography,
} from "@material-ui/core";
import HeaderMenu from "../../../../Components/HeaderMenu";
import { useHistory } from "react-router";
import React, { useState } from "react";
import Document from "./Document";
import Mail from "./Mail";
import Feedback from "./Feedback";
import InternalComments from "./InternalComments";
import CoachesComments from "../../../../Images/CoachesComments.png";
import CoachesMail from "../../../../Images/CoachesMail.png";
import CoachesDocuments from "../../../../Images/CoachesDocuments.png";
import CoachesFeedback from "../../../../Images/CoachesFeedback.png";
import User from "../../../../Images/User.png";
import { CenterFocusStrong } from "@material-ui/icons";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Fab } from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#F7F7F7",
    "& .MuiListItem-root.Mui-selected": {
      backgroundColor: "#981B1E1A",
    },
  },

  itemName: {
    fontSize: "14px",
  },
  large: {
    width: theme.spacing(13),
    height: theme.spacing(13),
  },
  listItemIcon: {
    position: "relative",
  },
  listItem: {
    display: "grid",
    gridTemplateColumns: "50px 1fr",
    paddingLeft: "24px",
  },
  viewProfileLink: {
    color: "rgb(25, 118, 210)",
    cursor: "pointer",
  },

  statusUpdate: {
    fontWeight: "bold",
    fontSize: "18px",
  },

  edit: {
    position: "absolute",
    bottom: "-8px",
    right: "-15px",
    padding: "11px",
    border: "2px solid white",
  },
}));

function Profile(props) {
  const classes = useStyles();
  const history = useHistory();
  // const history = useHistory();
  console.log(`history`, history);
  const selectedIndexViaRoute = history.location.state.selectedIndex;
  const pageUrlViaRoute = history.location.state.pageUrl;
  const [selectedIndex, setSelectedIndex] = useState(
    selectedIndexViaRoute == undefined ? 0 : selectedIndexViaRoute
  );
  const [pageUrl, setPageUrl] = useState(
    pageUrlViaRoute == undefined ? "document" : pageUrlViaRoute
  );

  const ListArr = [
    {
      name: "Documents",
      routeName: "document",
      icon: <img alt="" src={CoachesDocuments} width={16} height={16} />,
    },
    {
      name: "Mail",
      routeName: "mail",
      icon: <img alt="" src={CoachesMail} width={26} height={16} />,
    },
    {
      name: "Feedback",
      routeName: "feedback",
      icon: <img alt="" src={CoachesFeedback} width={20} height={20} />,
    },
    {
      name: "Internal Comments",
      routeName: "internalComments",
      icon: <img alt="" src={CoachesComments} width={20} height={20} />,
    },
  ];

  const coachData = history.location.state;
  const orgID = coachData.organisation_id;
  const employeeID = coachData.id;
  const editHandle = (params) => {
    // console.log(coachData);
    history.push(`/admin/organisation/${orgID}/employee/${employeeID}/edit`, {
      id: coachData.id,
      name: coachData.name,
      currentSelection: coachData,
      organisation_id: coachData.organisation_id,
      organisation_name: coachData.organisation_name,
    });
  };

  const viewProfile = (params) => {
    // console.log(coachData);
    history.push("/CoachDetail", coachData);
  };
  return (
    <Box component="div">
      <HeaderMenu />

      <Grid container direction="row">
        <Grid item xs={3} justify="center">
          <Box
            style={{
              backgroundColor: "#EEEEEE",
              position: "relative",
              paddingTop: "29px ",
            }}
          >
            <ArrowBackIosIcon
              style={{
                fontSize: 30,
                color: "#077F83",
                cursor: "pointer",
                paddingLeft: "26.5px",
                position: "absolute",
              }}
              onClick={() => {
                history.goBack();
              }}
            />

            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <ListItemIcon className={classes.listItemIcon}>
                  <Avatar
                    alt="Remy Sharp"
                    src={User}
                    className={classes.large}
                  />
                  <Fab
                    style={{ transform: "scale(0.5)" }}
                    color="primary"
                    aria-label="edit"
                    className={classes.edit}
                  >
                    <Edit onClick={editHandle} />
                  </Fab>
                </ListItemIcon>
              </Grid>
              <Grid item xs={12}>
                <Box textAlign="center" mt={1}>
                  <Typography
                    variant="h2"
                    style={{ fontWeight: "bold" }}
                    className=""
                  >
                    {history.location.state.name}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box textAlign="center" mt={1}>
                  <Typography variant="h2" style={{ opacity: "50%" }}>Coach</Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box textAlign="center" my={1}>
                  <Typography
                    onClick={viewProfile}
                    className={classes.viewProfileLink}
                    variant="subtitle1"
                    style={{ textDecorationLine: "underline" }}
                  >
                    View Profile
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box
            style={{ backgroundColor: "#EEEEEE", position: "relative" }}
            pb={2}
          >
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={4}>
                <Box textAlign="center" mt={1}>
                  <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>10</Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box textAlign="center" mt={1}>
                  <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>5</Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box textAlign="center" mt={1}>
                  <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>5</Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              style={{ opacity: "50%" }}
            >
              <Grid item xs={4}>
                <Box textAlign="center" mt={1}>
                  <Typography variant="h2">Completed</Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box textAlign="center" mt={1}>
                  <Typography variant="h2">In progress</Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box textAlign="center" mt={1}>
                  <Typography variant="h2">Pending</Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Divider />
          {ListArr.map((option, index) => {
            return (
              <>
                <List
                  classes={{ root: classes.root }}
                  component="nav"
                  aria-label="main mailbox folders"
                >
                  <ListItem
                    className={classes.listItem}
                    button
                    selected={selectedIndex === index}
                    onClick={() => {
                      setPageUrl(option.routeName);
                      setSelectedIndex(index);
                    }}
                  >
                    <span style={{ display: "flex", justifyContent: "left" }}>
                      {option.icon}
                    </span>
                    <ListItemText
                      primary={<Typography variant="h2">{option.name}</Typography>}
                    />
                  </ListItem>
                </List>
                <Divider />
              </>
            );
          })}
        </Grid>
        <Grid item xs={9}>
          {pageUrl == "document" && <Document id={history.location.state.id} />}
          {pageUrl == "mail" && <Mail id={history.location.state.id} />}
          {pageUrl == "feedback" && <Feedback />}
          {pageUrl == "internalComments" && <InternalComments />}
        </Grid>
      </Grid>
    </Box >
  );
}

export default Profile;
